export const CONTACT_SALES_SLICE_TYPE = 'contact_sales';
